<template>
  <div class="chat">
    <ul class="chat-messages">
      <li class="" v-for="(message, key) in renderMessages" :key="key">
        <h5 class="mb-2">{{ message.user.name }}</h5>
        <div>
          <pre
            style="white-space: pre-wrap"
          ><code>{{ message.description }}</code></pre>
        </div>
        <div v-if="message.media.length">
          <div v-for="(media, i) in message.media" :key="i">
            <a class="link" target="_blank" :href="media.original_url">{{
              media.file_name
            }}</a>
          </div>
        </div>
        <small class="mt-2">
          {{ message.created_at | dateTimeFormat }}
        </small>
      </li>
    </ul>

    <div class="chat-control" ref="chatElement">
      <div>
        <textarea
          ref="inputElement"
          @keyup.enter="sendMessage"
          class="form-control"
          rows="2"
          v-model="data.description"
          placeholder="Сообщение / Xabar"
        ></textarea>

        <div class="chat-control-buttons">
          <zip-upload-button
            v-model="data.media"
            class="mr-2"
            @input="sendMessage"
            titleKey="attach_file"
            title="Прикрепить файл"
          />
          <button class="btn btn-icon btn-sm btn-info" @click="sendMessage">
            <span class="ti-email"></span>
            <span>{{ "push" | setText("Отправить") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorNotify, toFormData } from "@/plugins/functions";

export default {
  data() {
    return {
      data: {
        media: null,
        description: null,
      },
      timer: 0,
    };
  },
  props: {
    value: {
      type: Array,
    },
    id: {
      default: null,
    },
    user_id: {
      default: null,
    },
    refresh: {
      default: function () {
        return;
      },
    },
  },
  beforeDestroy() {
    this.$socket.off(`retailbox_database_private-ticket:${this.user_id}`);
  },
  mounted() {
    try {
      this.$socket.on(
        `retailbox_database_private-ticket:${this.user_id}`,
        (msg) => {
          try {
            if (msg.ticket_id == this.id && this.$refs.chatElement) {
              this.messages.push(msg.ticketMessage);
              // console.log(msg.ticketMessage);
              this.scrollToBottom();
            } else {
              return false;
            }
          } catch (error) {}
        }
      );

      this.scrollToBottom();
    } catch (error) {
      console.log(error);
    }

    setInterval(() => {
      this.timer--;
    }, 1000);
  },
  computed: {
    // newMessage(val) {
    //   return this.$store.state.ticket;
    // },
    renderMessages: {
      get() {
        return Array.from(new Set(this.messages.map((obj) => obj.id))).map(
          (id) => this.messages.find((obj) => obj.id === id)
        );
      },
    },
    messages: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    refreshWithTimeout() {
      this.timer = 10;
      this.refresh();
    },
    scrollToBottom() {
      try {
        this.$nextTick(() => {
          const targetElement = this.$refs.chatElement;
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        this.$refs.inputElement.focus();
      } catch (error) {}
    },
    sendMessage() {
      this.$loading(true);

      try {
        if (this.data.media && !this.data.description) {
          this.data.description = "Прикрепил документ / Ilova qilingan hujjat";
        }
      } catch (error) {}

      return this.$http({
        method: "post",
        data: toFormData(this.data),
        url: `tickets/${this.id}/messages`,
      })
        .then((response) => {
          const data = response.data;
          this.data = {
            media: null,
            description: null,
          };
          this.messages.push(data.data);
          this.scrollToBottom();
          return data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

<style lang="scss">
.chat {
  &-control {
    text-align: right;
    // -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    // -moz-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    // box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    padding: 15px 0 0 0;
    z-index: 9;
    // position: fixed;
    bottom: 0;
    right: 0;
    left: auto;
    background: #fff;
    width: 100%;

    & > div {
      width: auto;
    }
    &-buttons {
      margin-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: right;
    }
  }

  &-messages {
    & > li {
      display: block;
      background: #f2f2f2;
      margin-bottom: 10px;
      padding: 10px;
      border-radius: 10px;
      & h5 {
        font-size: 14px;
        font-weight: bold;
      }
      & pre {
        font-size: 12px;
      }
      & small {
        color: #999;
      }
    }
  }
}
</style>